<template>
    <footer>
        <div class="container">
            <p class="link-box">
                <a class="link-box-a" target="_blank" href="https://www.arknights.jp/terms_of_service">利用規約</a>
                <a class="link-box-a" target="_blank" href="https://www.arknights.jp/privacy_policy">プライバシーポリシー</a>
            </p>
            <!-- <img src="@/assets/images/footer/hypergryph_yostar.svg" class="logo" alt="logo">
            <p class="copyright-info">
                <span>©2017 Hypergryph Co., Ltd</span>
                <span> ©2018 Yostar, Inc.</span>
            </p> -->
            <img src="@/assets/images/footer/hypergryph&montagne_white.svg" class="logo" alt="logo">
            
        </div>
        
        <div class="totop-button" @click="toTop">TOP</div>
    </footer>
</template>

<script>
export default {
    name: "FooterBar",

    components: {

    },
    data: () => ({
    }),
    created() {
    },
    mounted() {

    },
    watch: {

    },
    computed: {

    },
    methods: {
        toTop() {
            window.scrollTo(0, 0);
        },
    },
};
</script>

<style lang="scss" scoped>
footer {
    width: 100%;
    height: auto !important;
    box-sizing: border-box;
    padding: pxTorem(33px) 0 pxTorem(78px);
    background: #000;
    border-top: 1px solid #535353;
    position: relative;

    .container {
        width: pxTorem(640px);
        margin: 0 auto;

        .link-box {
            text-align: center;
            margin-bottom: pxTorem(22px);
            
            .link-box-a {
                color: #fff;
                font-family: 'Noto Sans JP', sans-serif;
                font-size: pxTorem(18px);

                &:not(:last-child) {
                    &::after {
                        content: "|";
                        color: #fff;
                        margin: 0 pxTorem(13px);
                    }
                }

                &:hover {
                    color: #00b2ff;
                }
            }
        }
        .logo {
            display: block;
            width: 122%;
            height: pxTorem(87px);
            object-fit: cover;
            transform: translateX(-50%);
            position: relative;
            left: 50%;
            //  image-rendering:-moz-crisp-edges;
            // image-rendering:-o-crisp-edges;
            // image-rendering:-webkit-optimize-contrast;
            // image-rendering: crisp-edges;
            // -ms-interpolation-mode:nearest-neighbor;
        }
        .copyright-info {
            width: 100%;
            box-sizing: border-box;
            padding: 0 pxTorem(35px);
            font-family: 'Noto Sans JP', sans-serif;
            font-size: pxTorem(14px);
            color: #fff;
            text-align: center;
            display: flex;
            justify-content: space-between;
        }
    }
    .totop-button {
        display: none;
    }
}

@media screen and (max-width: 600px) {
    footer {
        width: 100%;
        height: auto !important;
        box-sizing: border-box;
        padding: MpxTorem(63px) 0 pxTorem(168px);
        background: #000;
        border-top: 1px solid #535353;
        position: relative;

        .container {
            width: MpxTorem(750px);
            margin: 0 auto;

            .link-box {
                text-align: center;
                margin-bottom: pxTorem(22px);
                
                .link-box-a {
                    color: #fff;
                    font-family: 'Noto Sans JP', sans-serif;
                    font-size: MpxTorem(40px);

                    &:not(:last-child) {
                        &::after {
                            content: "|";
                            color: #fff;
                            margin: 0 MpxTorem(15px);
                        }
                    }

                    &:hover {
                        color: #00b2ff;
                    }
                }
            }
            .logo {
                display: block;
                width: 100%;
            }
            .copyright-info {
                width: 100%;
                box-sizing: border-box;
                padding: 0 pxTorem(35px);
                font-family: 'Noto Sans JP', sans-serif;
                font-size: pxTorem(14px);
                color: #fff;
                text-align: center;
                display: flex;
                justify-content: space-between;
            }
        }
        .totop-button {
            position: absolute;
            top: MpxTorem(10px);
            right: MpxTorem(35px);
            z-index: 997;
            font-size: MpxTorem(75px);
            display: block;
        }
    }
}
</style>
